import React from 'react';

const NoWorkspacesMessage: React.FC = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <p className="helpbox-vu-content-wrapper helpbox-content-wrapper">
            Sorry, no workspaces are assigned to you.
          </p>
          <p>
            Please <a href="#contact" target="_application">contact support</a> to correct this problem.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoWorkspacesMessage;
